import styled from "styled-components";
import { useState } from "react";

// Components
import SimulatorManagement from "./components/SimulatorManagement";
import SimulatorAnalytics from "./components/SimulatorAnalytics";
import SimulatorTasks from "./components/SimulatorTasks";
import Tabs from "../../components/common/Tabs";
import { useSelector } from "react-redux";

const Simulator = () => {

    const [tabSelected, setTabSelected] = useState(0);

    const { ondemand } = useSelector((state) => state.ondemand);

    const isLeader = true;

    const tabs = [
        { id: 0, label: "Mis simuladores" },
        ondemand.is_admin ? { id: 1, label: "Gestión de simuladores" } : null,
        ondemand.is_admin ? { id: 2, label: "Analíticas generales" } : null,
    ]

    const handleTab = (newValue) => {
        setTabSelected(newValue);
    }

    return (
        <Container>
            <Tabs
                tabValue={tabSelected}
                handleTabValue={handleTab}
                tabOptions={tabs}
            />
            {
                tabSelected === 0 && <SimulatorTasks />
            }
            {
                (tabSelected === 1 && isLeader) && <SimulatorManagement />
            }
            {
                tabSelected === 2 && <SimulatorAnalytics />
            }
        </Container>
    )
}

export default Simulator;

const Container = styled.div`
    min-height: 90vh;
    height: 100%;
`